const $ = jQuery;

class SliderLeft {
    constructor() {
        this.slider = $('.c-slider.cc-slider_left');
        this.init();
    }
    
    init() {
        if(this.slider.length > 0){
            this.initSlider();
        }
    }

    initSlider() {
        this.slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true,
            arrows: false,
            dots: true,
            infinite: true,
            speed: 300,
            fade: true,
            cssEase: 'ease-in-out',
            pauseOnHover: false,
        });
    }
}

export default SliderLeft;